import _ from 'lodash'

export default function passThruFilter(list, filter, params) {

    let currentList = [].concat(list)

    for (let n in filter) {
        if (filter[n].type === 'string') {
            currentList = currentList.filter(list => {
                // Sanitize the string for Regex if the search term is not default
                let sanitizedStr = (filter[n].value1 !== '[a-zA-Z0-9]' && filter[n].value1 !== '.*') ? _.escapeRegExp(filter[n].value1) : filter[n].value1

                var re = new RegExp(sanitizedStr, 'i')
                return re.test(list[n])
            })
        }
        if (filter[n].type === 'strEnum') {
            currentList = currentList.filter(list => {
                // Sanitize the string for Regex if the search term is not default
                let sanitizedStr = (filter[n].value1 !== '[a-zA-Z0-9]' && filter[n].value1 !== '.*') ? _.escapeRegExp(filter[n].value1) : filter[n].value1

                var re = new RegExp(sanitizedStr, 'i')
                return re.test(list[n])
            })
        }
        // if (filter[n].type === 'dateTime') {
        //     currentList = currentList.filter(list => {
        //         // Sanitize the string for Regex if the search term is not default
        //         let sanitizedStr = (filter[n].value1 !== '[a-zA-Z0-9]' && filter[n].value1 !== '.*') ? _.escapeRegExp(filter[n].value1) : filter[n].value1

        //         var re = new RegExp(sanitizedStr, 'i')
        //         return re.test(list[n])
        //     })
        // }
        if (filter[n].type === 'boolean' && filter[n].value1 !== "") {
            currentList = currentList.filter(list => list[n] === Number(filter[n].value1))
        }
        if (filter[n].type === 'reference' && filter[n].value1 !== "") {
            currentList = currentList.filter(list => list[n] === filter[n].value1)
        }
    }

    return currentList
}


// WEBPACK FOOTER //
// ./src/components/utilities/passThruFilter.js